import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class CheckboxButtonInput extends Component {
  constructor(data) {
    super(data);
    this.state = {
      isChecked: false,
      value: '',
    };
  }
  toggleChange() {
    const { name } = this.props;
    if (this.state.isChecked) {
      this.setState({
        isChecked: !this.state.isChecked,
        value: '',
      });
      this.props.onChange({
        target : {
          name: name,
          value: '',
          type: 'input'
        }
      });
    } else {
      this.setState({
        isChecked: !this.state.isChecked,
      });
    }
  }
  changeValue(event) {
    const target = event.target;
    const value = target.value;
    this.setState({
      value: value,
    });
    this.props.onChange(event);
  }
  render() {
    const { rootClassname, isDisabled, label, name } = this.props;
    const finalRootClass = classnames(style.root, rootClassname);
    const inputRootClass = classnames(style.root_input, rootClassname);
    return (
      <div className={finalRootClass}>
        <div>
          <input type="checkbox" disabled={isDisabled} onChange={this.toggleChange.bind(this)} checked={this.state.isChecked}/>
          <label>{label}</label>
        </div>
        <input
          name={name}
          className={inputRootClass}
          type={this.props.type}
          value={this.state.value}
          disabled={!this.state.isChecked}
          onChange={this.changeValue.bind(this)}
        />
      </div>
    );
  }
}

CheckboxButtonInput.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/CheckboxButtonInput/index.js